import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { reviews } from "../data/Reviews";

export default function Reviews() {
  const { t, i18n } = useTranslation();
  const [index, setIndex] = useState(0);

  const current = reviews[index];
  const lng = (i18n.language || "hr").slice(0, 2);
  const text =
    current[`text_${lng}`] || current.text_en || current.text_hr || "";

  const next = () => setIndex((i) => (i + 1) % reviews.length);
  const prev = () => setIndex((i) => (i - 1 + reviews.length) % reviews.length);

  const stars = "★".repeat(Math.round(current.rating));

  return (
    <section id="reviews" className="section">
      <div className="container">
        <header className="section-header">
          <h2>{t("reviews.sectionTitle")}</h2>
          <p>{t("reviews.sectionSubtitle")}</p>
        </header>

        <div className="reviews-slider">
          <button className="slider-arrow" onClick={prev}>
            ‹
          </button>
          <div className="review-card">
            <p className="review-text">"{text}"</p>
            <div className="review-footer">
              <div>
                <div className="review-name">{current.name}</div>
              </div>
              <div className="review-stars">{stars}</div>
            </div>
          </div>
          <button className="slider-arrow" onClick={next}>
            ›
          </button>
        </div>
      </div>
    </section>
  );
}
